import React, { Fragment, useEffect, useRef, useState } from 'react';
import produce from 'immer';
import { useClickAway } from 'react-use';
import { DropdownContainer, DropdownList, Separator, StyledDropdown } from './Dropdown.styles';
import { DropdownApplyButton } from './DropdownApplyButton';
import { DropdownButton } from './DropdownButton';
import { DropdownItem } from './DropdownItem';
import { equals } from '../../../../play-core/utils/array-helper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GroupedDropdown = ({
  title,
  isLoading,
  groups,
  onChange
}) => {
  const dropdownRef = useRef(null);
  const [isOpen, setOpen] = useState(false);
  const [editingGroups, setEditingGroups] = useState(groups);
  useClickAway(dropdownRef, () => setDropdownOpen(false));
  useEffect(() => setEditingGroups(groups), [groups]);
  const isSelected = (groupIndex, itemId) => editingGroups[groupIndex].selectedItems.includes(itemId);
  const toggleItem = (groupIndex, itemId) => {
    const newGroups = produce(editingGroups, draftGroups => {
      const group = draftGroups[groupIndex];
      if (group.selectedItems.includes(itemId)) {
        group.selectedItems = group.selectedItems.filter(item => item !== itemId);
      } else if (group.singleSelection) {
        group.selectedItems = [itemId];
      } else {
        group.selectedItems.push(itemId);
      }
    });
    setEditingGroups(newGroups);
  };
  const setDropdownOpen = shouldOpen => {
    if (isOpen) {
      hasChanges && onChange(editingGroups);
    }
    setOpen(shouldOpen);
  };
  const hasChanges = groups.some((group, groupIndex) => {
    const editingGroup = editingGroups[groupIndex];
    if (editingGroup) {
      return !equals(group.selectedItems, editingGroup.selectedItems);
    }
    return false;
  });
  return /*#__PURE__*/_jsxs(StyledDropdown, {
    ref: dropdownRef,
    children: [/*#__PURE__*/_jsx(DropdownButton, {
      title: title,
      isOpen: isOpen,
      isLoading: isLoading,
      onClick: () => setDropdownOpen(!isOpen)
    }), isOpen && !isLoading && /*#__PURE__*/_jsxs(DropdownContainer, {
      children: [/*#__PURE__*/_jsx(DropdownList, {
        children: editingGroups.map((group, groupIndex) => /*#__PURE__*/_jsxs(Fragment, {
          children: [group.items.map(item => /*#__PURE__*/_jsx(DropdownItem, {
            item: item,
            isSelected: isSelected(groupIndex, item.id),
            onToggle: () => toggleItem(groupIndex, item.id)
          }, `${group.id}-${item.id}`)), groupIndex < groups.length - 1 && /*#__PURE__*/_jsx(Separator, {})]
        }, group.id))
      }), /*#__PURE__*/_jsx(DropdownApplyButton, {
        onClick: () => setDropdownOpen(false),
        hasChanges: hasChanges
      })]
    })]
  });
};